import {Controller, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {CreateKycBasicFormStepFormValues} from "../../schema-validation";

export function KycPostalCodeFormField() {
  const {control} = useFormContext<CreateKycBasicFormStepFormValues>();

  return (
    <FormField
      id="postalCode"
      label="Postal code"
      renderInput={(id) => (
        <Controller
          control={control}
          name="postalCode"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space size={8} direction="vertical" style={{display: "flex"}}>
              <Input
                id={id}
                status={error?.message ? "error" : ""}
                onChange={onChange}
                onBlur={onBlur}
                size="large"
                value={value === null ? undefined : value}
                placeholder="Enter your postal code"
                ref={ref}
              />
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      )}
    />
  );
}
